// extracted by mini-css-extract-plugin
export default {"item":"SingleComment_item__tFQR3","author":"SingleComment_author__3XjIa","comment":"SingleComment_comment__ndFmF"};